const sdIssuesWorkflow = {
  new: "IEADCDYKJMBSJVWU",
  inProgress: "IEADCDYKJMBSJVW6",
  waitingOnCustomerFeedback: "IEADCDYKJMBU2X56",
  resolved: "IEADCDYKJMBSJVWV",
  duplicated: "IEADCDYKJMBSJVXU",
  cancelled: "IEADCDYKJMBSJVXL"
};

const foldersId = {
  issues: "IEADCDYKI4QZOTIF",
  hardware: "IEADCDYKI4QZOUIM",
  suggestions: "IEADCDYKI4Q5IQEQ"
};

export { sdIssuesWorkflow, foldersId };
